// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/about/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/about/parallax.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/images/about/banner-tab.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/images/about/banner-sm.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layer1{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: bottom center;
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    height: 100vh;
    position: fixed;
    z-index: -1;
}

.layer2{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.layer2 .text-container{
    position: relative;
    top: 2rem;
}
.layer2 .text-container h1{
    width: 70%;
}
.layer2 .text-container h1 span{
    color: #FAEC24;
}

.layer3{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-position: right bottom;
    background-size: contain ;
    background-repeat: no-repeat;
    width: 100%;
    position: relative;
    right: 6rem;
    height: fit-content; 
    position: fixed;
    z-index: -1;
    height: 80%;
}

@media (min-width:768px) and (max-width:992px) {

    .layer1{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    }
    .layer3{
        right: 0;
        bottom: 0;
        height: 80% !important;
    }
    .layer2 .text-container h1{
        width: 90%;
    }
}

@media (max-width:576px){
    .layer1{
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    }
    .layer2 {
        align-items: end;
    }
    .layer2 .text-container{
        top: 0;
        margin-bottom: 20%;
    }
    .layer2 .text-container h1{
        width: 90%;
    }
    .layer3{
        left: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/common-componets/Parallax/Parallax.css"],"names":[],"mappings":"AAAA;IACI,yDAA8D;IAC9D,kCAAkC;IAClC,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;IACX,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,UAAU;AACd;AACA;IACI,cAAc;AAClB;;AAEA;IACI,yDAAgE;IAChE,iCAAiC;IACjC,yBAAyB;IACzB,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,WAAW;AACf;;AAEA;;IAEI;QACI,yDAAkE;IACtE;IACA;QACI,QAAQ;QACR,SAAS;QACT,sBAAsB;IAC1B;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,yDAAiE;IACrE;IACA;QACI,gBAAgB;IACpB;IACA;QACI,MAAM;QACN,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ","sourcesContent":[".layer1{\r\n    background-image: url(../../../public/images/about/banner.png);\r\n    background-position: bottom center;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    width: 100%;\r\n    height: 100vh;\r\n    position: fixed;\r\n    z-index: -1;\r\n}\r\n\r\n.layer2{\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n}\r\n.layer2 .text-container{\r\n    position: relative;\r\n    top: 2rem;\r\n}\r\n.layer2 .text-container h1{\r\n    width: 70%;\r\n}\r\n.layer2 .text-container h1 span{\r\n    color: #FAEC24;\r\n}\r\n\r\n.layer3{\r\n    background-image: url(../../../public/images/about/parallax.png);\r\n    background-position: right bottom;\r\n    background-size: contain ;\r\n    background-repeat: no-repeat;\r\n    width: 100%;\r\n    position: relative;\r\n    right: 6rem;\r\n    height: fit-content; \r\n    position: fixed;\r\n    z-index: -1;\r\n    height: 80%;\r\n}\r\n\r\n@media (min-width:768px) and (max-width:992px) {\r\n\r\n    .layer1{\r\n        background-image: url(../../../public/images/about/banner-tab.png);\r\n    }\r\n    .layer3{\r\n        right: 0;\r\n        bottom: 0;\r\n        height: 80% !important;\r\n    }\r\n    .layer2 .text-container h1{\r\n        width: 90%;\r\n    }\r\n}\r\n\r\n@media (max-width:576px){\r\n    .layer1{\r\n        background-image: url(../../../public/images/about/banner-sm.png);\r\n    }\r\n    .layer2 {\r\n        align-items: end;\r\n    }\r\n    .layer2 .text-container{\r\n        top: 0;\r\n        margin-bottom: 20%;\r\n    }\r\n    .layer2 .text-container h1{\r\n        width: 90%;\r\n    }\r\n    .layer3{\r\n        left: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
